import React, { createContext, useContext } from "react";
import { Toast } from "../toast";
import { Message } from "../message";
import { ModalManager } from "../modal/ModalManager";
import { ActionSheetManager } from "../action-sheet";
var ComponentContext = createContext(null);
export function ComponentProvider(_a) {
    var children = _a.children;
    var parentContext = useContext(ComponentContext);
    return (React.createElement(ComponentContext.Provider, { value: {} },
        children,
        !parentContext && (React.createElement(React.Fragment, null,
            React.createElement(Toast, null),
            React.createElement(Message, null),
            React.createElement(ModalManager, null),
            React.createElement(ActionSheetManager, null)))));
}
//# sourceMappingURL=ComponentProvider.js.map